import React, { Component } from 'react';
import { Icon, Button } from "@blueprintjs/core";
import './index.css';


class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue:'',
    }
    this.handleClick = this.handleClick.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.selectHandler = this.selectHandler.bind(this);
  }

  handleClick(e, key){
    const { inputValue } = this.state;
    if (e.key === 'Enter' || key === 'btn') {
      if(typeof this.props.onClick === 'function'){
        this.props.onClick(inputValue);
      }
    }
  }

  onChangeHandler(event){
    let value = event.target.value;
    this.setState({inputValue: value})
    if (this.props.onChange){this.props.onChange(value)}
  }

  selectHandler(item){
    this.props.options.searchResults = [];
    this.setState({inputValue:item.symbol})
    if (this.props.onSelect){this.props.onSelect(item)}
  }

  render() {
    const { lang, placeholder, backgroundColor, optionsClass, inputColor, placeholderWhite, options } = this.props;
    return (
      <div className="search-input-component-container">
        <div className="bp3-input-group bp3-round">
          <Icon icon="search" iconSize={14} />
          <input id={placeholderWhite ? 'search-input-component':''} type="text" className="bp3-input" placeholder={lang === 'fa' ? placeholder.fa : placeholder.en } 
            style={{backgroundColor: backgroundColor ? backgroundColor : '#fff', color: inputColor ? inputColor : '#fff',direction: lang==='fa'?'rtl':'ltr'}} onKeyDown={this.handleClick}
            onChange={e => {this.onChangeHandler(e)}} value={this.state.inputValue}
          />
          <Button intent={'primary'} minimal icon="arrow-right" onClick={(e)=>this.handleClick(e,'btn')}/>
        </div>
        <div style={{backgroundColor: backgroundColor ? backgroundColor : '#fff',direction: lang==='fa'?'rtl':'ltr'}} 
          className={optionsClass ? optionsClass + ' search-input-select-list-container' : 'search-input-select-list-container'}>
          {
            options && options.searchResults.map((item, index)=>{
              return (<div className= 'search-input-item-select' onClick={()=>this.selectHandler(item)} key={item.symbol + index}>{item.symbol}</div>)})
          }
        </div>
      </div>
    );
  }
}



export default SearchInput;
